import clsx from 'clsx';
import { InputState } from './types';

export const getOutlineColor = (type: InputState['type'] | undefined) => {
  return clsx(
    {
      'outline outline-2': type !== undefined,
      'outline-state-error': type === 'error',
      'outline-state-success': type === 'success',
      'outline-state-warning': type === 'warning',
      'outline-state-info': type === 'info',
      'focus:outline focus:outline-2 focus:outline-state-focus': type === undefined,
    },
    '-outline-offset-2'
  );
};
